import script from "./SiteWidgetsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteWidgetsManager.vue?vue&type=script&setup=true&lang=js"

import "./SiteWidgetsManager.vue?vue&type=style&index=0&id=1ba43aa7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ba43aa7"]])

export default __exports__